const STORAGE_KEY = 'huren_visited_profiles';
const MAX_ENTRIES = 200;

function readSet(): Set<string> {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return new Set(raw ? (JSON.parse(raw) as string[]) : []);
    } catch {
        return new Set();
    }
}

function writeSet(set: Set<string>): void {
    try {
        // Keep only the most recent MAX_ENTRIES
        const arr = Array.from(set).slice(-MAX_ENTRIES);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch {
        // localStorage unavailable (SSR, private mode quota) — fail silently
    }
}

export function useVisitedProfiles() {
    const isVisited = (id: string | number): boolean =>
        readSet().has(String(id));

    const markVisited = (id: string | number): void => {
        const set = readSet();
        set.add(String(id));
        writeSet(set);
    };

    return { isVisited, markVisited };
}
